// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-datepicker-popper {\r\n  z-index: 1000;\r\n}\r\n\r\n.react-datepicker__close-icon {\r\n  padding: 6px 6px 0px 0px;\r\n}\r\n\r\n.react-datepicker__close-icon::after {\r\n  content: \"✕\";\r\n  background-color: transparent;\r\n  color: #4d4b49;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
